import ETAIframeModal from 'features/eta/modals/ETAIframeModal';
import DocumentUploadReminderInformModal from 'features/pii/modals/DocumentUploadReminderInformModal';
import FormPIIModal from 'features/pii/modals/FormPIIModal';
import FormPIIOTPVerificationModal from 'features/pii/modals/FormPIIOTPVerificationModal';
import FormPIIProfileContactUsModal from 'features/pii/modals/FormPIIProfileContactUsModal';
import FormPIIProfileDetailsExistInformModal from 'features/pii/modals/FormPIIProfileDetailsExistInformModal';
import FormPIIVerificationSuccessfulModal from 'features/pii/modals/FormPIIVerificationSuccessfulModal';
import PIIVerifyNowModal from 'features/pii/modals/PIIVerifyNowModal';
import FormProfileKYCModal from 'features/profileKYC/modals/FormProfileKYCModal';
import FormProfileKYCSuccessModal from 'features/profileKYC/modals/FormProfileKYCSuccessModal';
import ReferralAFiendChooseToShareModal from 'features/referral/modals/ReferralAFiendChooseToShareModal';
import ReferralLinkExpiredModal from 'features/referral/modals/ReferralLinkExpiredModal';
import RegisterWelcomeModal from 'features/register/modals/WelcomeModal';
import AccountWithEmailExistInformModal from 'features/register2.0/modals/AccountWithEmailExistInformModal';
import AddPaytoAccountModal from 'features/to/modals/AddPaytoAccountModal';
import AuthorisePaytoAccountModal from 'features/to/modals/AuthorisePaytoAccountModal';
import AuthorisePaytoAccountRejectedModal from 'features/to/modals/AuthorisePaytoAccountRejectedModal';
import AuthorisePaytoAccountSuccessModal from 'features/to/modals/AuthorisePaytoAccountSuccessModal';
import AuthorisePaytoAccountTimeoutModal from 'features/to/modals/AuthorisePaytoAccountTimeoutModal';
import DeletePaytoAccountAgreementModal from 'features/to/modals/DeletePaytoAccountAgreementModal';
import EditPaytoAccountAgreementModal from 'features/to/modals/EditPaytoAccountAgreementModal';
import PaytoNoChangeModal from 'features/to/modals/PaytoNoChangeModal';
import PaytoOTPVerificationModal from 'features/to/modals/PaytoOTPVerificationModal';
import UpdatePaytoAccountSuccessModal from 'features/to/modals/UpdatePaytoAccountSuccessModal';
import CheckCameraToTakePhotoEnableAlertModal from 'features/uploadDocuments/modals/CheckCameraToTakePhotoEnableAlertModal';
import CustomCameraMaskToCapturePhotoModal from 'features/uploadDocuments/modals/CustomCameraMaskToCapturePhotoModal';
import {
  AlertModal,
  CancelFxAddTransactionModal,
  ChangePickupLocationTypeModal,
  CreateReceiverModal,
  FxCalculatorModalRateTimeoutModal,
  FxCalculatorModalTimeoutModal,
  PaymentInstructionModal,
  PickupLocationPreviewModal,
  PickupLocationViewDetailsModal,
  RemovePickupLocationByPayAmountChangeModal,
  SendMoneyReceiverModal,
  ServiceAlertsModal,
} from '../modals';
import CancelNavigatingAwayFromFlowModal from '../modals/CancelNavigatingAwayFromFlowModal';
import EventIframeModal from '../modals/EventIframeModal';
import FxDisallowOrderMakePaymentModal from '../modals/FxDisallowOrderMakePaymentModal';
import FxMakePaymentExpiredModal from '../modals/FxMakePaymentExpiredModal';
import FxPaymentInstructionModal from '../modals/FxPaymentInstructionModal';
import FxPickupDateNoticeModal from '../modals/FxPickupDateNoticeModal';
import MaintenanceModal from '../modals/MaintenanceModal';
import SystemErrorModal from '../modals/SystemErrorModal';
import TxnSubmitErrorModal from '../modals/TxnSubmitErrorModal';

const SERVICE_ALERTS_MODAL = 'SERVICE_ALERTS_MODAL';
const CREATE_RECEIVER_MODAL = 'CREATE_RECEIVER_MODAL';
const SEND_MONEY_RECEIVER_MODAL = 'SEND_MONEY_RECEIVER_MODAL';
const PAYMENT_INSTRUCTION_MODAL = 'PAYMENT_INSTRUCTION_MODAL';
const FX_PAYMENT_INSTRUCTION_MODAL = 'FX_PAYMENT_INSTRUCTION_MODAL';
const CHANGE_PICKUP_LOCATION_TYPE_MODAL = 'CHANGE_PICKUP_LOCATION_TYPE_MODAL';
const CANCEL_FX_ADD_TRANSACTION_MODAL = 'CANCEL_FX_ADD_TRANSACTION_MODAL';
const ALERT_MODAL = 'ALERT_MODAL';
const REMOVE_PICKUP_LOCATION_BY_PAY_AMOUNT_CHANGE =
  'REMOVE_PICKUP_LOCATION_BY_PAY_AMOUNT_CHANGE';
const FX_CALCULATOR_MODAL_TIMEOUT_MODAL = 'FX_CALCULATOR_MODAL_TIMEOUT_MODAL';
const FX_CALCULATOR_MODAL_RATE_TIMEOUT_MODAL =
  'FX_CALCULATOR_MODAL_RATE_TIMEOUT_MODAL';
const PICKUP_LOCATION_PREVIEW_MODAL = 'PICKUP_LOCATION_PREVIEW_MODAL';
const PICKUP_LOCATION_VIEW_DETAILS_MODAL = 'PICKUP_LOCATION_VIEW_DETAILS_MODAL';
const EVENT_IFRAME_MODAL = 'EVENT_IFRAME_MODAL';
const MAINTENANCE_MODAL = 'MAINTENANCE_MODAL';
const SYSTEM_ERROR_MODAL = 'SYSTEM_ERROR_MODAL';
const FX_MAKE_PAYMENT_EXPIRED_MODAL = 'FX_MAKE_PAYMENT_EXPIRED_MODAL';
const FX_DISALLOW_ORDER_MAKE_PAYMENT_MODAL =
  'FX_DISALLOW_ORDER_MAKE_PAYMENT_MODAL';
const REFERRAL_A_FRIEND_CHOOSE_TO_SHARE_MODAL =
  'REFERRAL_A_FRIEND_CHOOSE_TO_SHARE_MODAL';
const REGISTER_WELCOME_MODAL = 'REGISTER_WELCOME_MODAL';
const REFERRAL_LINK_EXPIRED_MODAL = 'REFERRAL_LINK_EXPIRED_MODAL';
const ETA_IFRAME_MODAL = 'ETA_IFRAME_MODAL';
const ADD_PAYTO_ACCOUNT_MODAL = 'ADD_PAYTO_ACCOUNT_MODAL';
const AUTHORISE_PAYTO_ACCOUNT_MODAL = 'AUTHORISE_PAYTO_ACCOUNT_MODAL';
const AUTHORISE_PAYTO_ACCOUNT_TIMEOUT_MODAL =
  'AUTHORISE_PAYTO_ACCOUNT_TIMEOUT_MODAL';
const AUTHORISE_PAYTO_ACCOUNT_SUCCESS_MODAL =
  'AUTHORISE_PAYTO_ACCOUNT_SUCCESS_MODAL';
const AUTHORISE_PAYTO_ACCOUNT_REJECT_MODAL =
  'AUTHORISE_PAYTO_ACCOUNT_REJECT_MODAL';
const EDIT_PAYTO_ACCOUNT_AGREEMENT_MODAL = 'EDIT_PAYTO_ACCOUNT_AGREEMENT_MODAL';
const DELETE_PAYTO_ACCOUNT_AGREEMENT_MODAL =
  'DELETE_PAYTO_ACCOUNT_AGREEMENT_MODAL';
const UPDATE_PAYTO_ACCOUNT_SUCCESS_MODAL = 'UPDATE_PAYTO_ACCOUNT_SUCCESS_MODAL';
const PAYTO_NO_CHANGE_MODAL = 'PAYTO_NO_CHANGE_MODAL';
const PAYTO_OTP_VERIFICATION_MODAL = 'PAYTO_OTP_VERIFICATION_MODAL';
const FX_PICKUP_DATE_NOTICE_POPUP = 'FX_PICKUP_DATE_NOTICE_POPUP';
const ACCOUNT_WITH_EMAIL_EXIST_INFORM_MODAL =
  'ACCOUNT_WITH_EMAIL_EXIST_INFORM_MODAL';
const PII_VERIFY_NOW_MODAL = 'PII_VERIFY_NOW_MODAL';
const DOCUMENT_UPLOAD_REMINDER_INFORM_MODAL =
  'DOCUMENT_UPLOAD_REMINDER_INFORM_MODAL';
const FORM_PII_MODAL = 'FORM_PII_MODAL';
const FORM_PII_VERIFICATION_SUCCESSFUL_MODAL =
  'FORM_PII_VERIFICATION_SUCCESSFUL_MODAL';
const FORM_PII_OTP_VERIFICATION_MODAL = 'FORM_PII_OTP_VERIFICATION_MODAL';
const FORM_PII_PROFILE_DETAILS_EXIST_INFORM_MODAL =
  'FORM_PII_PROFILE_DETAILS_EXIST_INFORM_MODAL';
const FORM_PII_PROFILE_CONTACT_US_MODAL = 'FORM_PII_PROFILE_CONTACT_US_MODAL';
const TXN_SUBMIT_ERROR_POPUP = 'TXN_SUBMIT_ERROR_POPUP';
const CUSTOM_CAMERA_MASK_TO_CAPTURE_PHOTO_MODAL =
  'CUSTOM_CAMERA_MASK_TO_CAPTURE_PHOTO_MODAL';
const CHECK_CAMERA_TO_TAKE_PHOTO_ENABLE_ALERT_MODAL =
  'CHECK_CAMERA_TO_TAKE_PHOTO_ENABLE_ALERT_MODAL';
const FORM_PROFILE_KYC_MODAL = 'FORM_PROFILE_KYC_MODAL';
const FORM_PROFILE_KYC_SUCCESSFUL_MODAL = 'FORM_PROFILE_KYC_SUCCESSFUL_MODAL';
const CANCEL_NAVIGATING_AWAY_FROM_FLOW_MODAL =
  'CANCEL_NAVIGATING_AWAY_FROM_FLOW_MODAL';

export const PORTAL_NAME_MODAL_DEFINE = {
  [SERVICE_ALERTS_MODAL]: SERVICE_ALERTS_MODAL,
  [CREATE_RECEIVER_MODAL]: CREATE_RECEIVER_MODAL,
  [SEND_MONEY_RECEIVER_MODAL]: SEND_MONEY_RECEIVER_MODAL,
  [PAYMENT_INSTRUCTION_MODAL]: PAYMENT_INSTRUCTION_MODAL,
  [FX_PAYMENT_INSTRUCTION_MODAL]: FX_PAYMENT_INSTRUCTION_MODAL,
  [CHANGE_PICKUP_LOCATION_TYPE_MODAL]: CHANGE_PICKUP_LOCATION_TYPE_MODAL,
  [CANCEL_FX_ADD_TRANSACTION_MODAL]: CANCEL_FX_ADD_TRANSACTION_MODAL,
  [ALERT_MODAL]: ALERT_MODAL,
  [REMOVE_PICKUP_LOCATION_BY_PAY_AMOUNT_CHANGE]:
    REMOVE_PICKUP_LOCATION_BY_PAY_AMOUNT_CHANGE,
  [FX_CALCULATOR_MODAL_TIMEOUT_MODAL]: FX_CALCULATOR_MODAL_TIMEOUT_MODAL,
  [FX_CALCULATOR_MODAL_RATE_TIMEOUT_MODAL]:
    FX_CALCULATOR_MODAL_RATE_TIMEOUT_MODAL,
  [PICKUP_LOCATION_PREVIEW_MODAL]: PICKUP_LOCATION_PREVIEW_MODAL,
  [PICKUP_LOCATION_VIEW_DETAILS_MODAL]: PICKUP_LOCATION_VIEW_DETAILS_MODAL,
  [EVENT_IFRAME_MODAL]: EVENT_IFRAME_MODAL,
  [MAINTENANCE_MODAL]: MAINTENANCE_MODAL,
  [SYSTEM_ERROR_MODAL]: SYSTEM_ERROR_MODAL,
  [FX_MAKE_PAYMENT_EXPIRED_MODAL]: FX_MAKE_PAYMENT_EXPIRED_MODAL,
  [FX_DISALLOW_ORDER_MAKE_PAYMENT_MODAL]: FX_DISALLOW_ORDER_MAKE_PAYMENT_MODAL,
  [REFERRAL_A_FRIEND_CHOOSE_TO_SHARE_MODAL]:
    REFERRAL_A_FRIEND_CHOOSE_TO_SHARE_MODAL,
  [REGISTER_WELCOME_MODAL]: REGISTER_WELCOME_MODAL,
  [REFERRAL_LINK_EXPIRED_MODAL]: REFERRAL_LINK_EXPIRED_MODAL,
  [ETA_IFRAME_MODAL]: ETA_IFRAME_MODAL,
  [ADD_PAYTO_ACCOUNT_MODAL]: ADD_PAYTO_ACCOUNT_MODAL,
  [AUTHORISE_PAYTO_ACCOUNT_MODAL]: AUTHORISE_PAYTO_ACCOUNT_MODAL,
  [AUTHORISE_PAYTO_ACCOUNT_TIMEOUT_MODAL]:
    AUTHORISE_PAYTO_ACCOUNT_TIMEOUT_MODAL,
  [AUTHORISE_PAYTO_ACCOUNT_SUCCESS_MODAL]:
    AUTHORISE_PAYTO_ACCOUNT_SUCCESS_MODAL,
  [AUTHORISE_PAYTO_ACCOUNT_REJECT_MODAL]: AUTHORISE_PAYTO_ACCOUNT_REJECT_MODAL,
  [EDIT_PAYTO_ACCOUNT_AGREEMENT_MODAL]: EDIT_PAYTO_ACCOUNT_AGREEMENT_MODAL,
  [DELETE_PAYTO_ACCOUNT_AGREEMENT_MODAL]: DELETE_PAYTO_ACCOUNT_AGREEMENT_MODAL,
  [UPDATE_PAYTO_ACCOUNT_SUCCESS_MODAL]: UPDATE_PAYTO_ACCOUNT_SUCCESS_MODAL,
  [PAYTO_NO_CHANGE_MODAL]: PAYTO_NO_CHANGE_MODAL,
  [PAYTO_OTP_VERIFICATION_MODAL]: PAYTO_OTP_VERIFICATION_MODAL,
  [FX_PICKUP_DATE_NOTICE_POPUP]: FX_PICKUP_DATE_NOTICE_POPUP,
  [ACCOUNT_WITH_EMAIL_EXIST_INFORM_MODAL]:
    ACCOUNT_WITH_EMAIL_EXIST_INFORM_MODAL,
  [PII_VERIFY_NOW_MODAL]: PII_VERIFY_NOW_MODAL,
  [DOCUMENT_UPLOAD_REMINDER_INFORM_MODAL]:
    DOCUMENT_UPLOAD_REMINDER_INFORM_MODAL,
  [FORM_PII_MODAL]: FORM_PII_MODAL,
  [FORM_PII_VERIFICATION_SUCCESSFUL_MODAL]:
    FORM_PII_VERIFICATION_SUCCESSFUL_MODAL,
  [FORM_PII_OTP_VERIFICATION_MODAL]: FORM_PII_OTP_VERIFICATION_MODAL,
  [FORM_PII_PROFILE_DETAILS_EXIST_INFORM_MODAL]:
    FORM_PII_PROFILE_DETAILS_EXIST_INFORM_MODAL,
  [FORM_PII_PROFILE_CONTACT_US_MODAL]: FORM_PII_PROFILE_CONTACT_US_MODAL,
  [TXN_SUBMIT_ERROR_POPUP]: TXN_SUBMIT_ERROR_POPUP,
  [CUSTOM_CAMERA_MASK_TO_CAPTURE_PHOTO_MODAL]:
    CUSTOM_CAMERA_MASK_TO_CAPTURE_PHOTO_MODAL,
  [CHECK_CAMERA_TO_TAKE_PHOTO_ENABLE_ALERT_MODAL]:
    CHECK_CAMERA_TO_TAKE_PHOTO_ENABLE_ALERT_MODAL,
  [FORM_PROFILE_KYC_MODAL]: FORM_PROFILE_KYC_MODAL,
  [FORM_PROFILE_KYC_SUCCESSFUL_MODAL]: FORM_PROFILE_KYC_SUCCESSFUL_MODAL,
  [CANCEL_NAVIGATING_AWAY_FROM_FLOW_MODAL]:
    CANCEL_NAVIGATING_AWAY_FROM_FLOW_MODAL,
};

export const PORTAL_MODAL_REFERENCE = {
  [SERVICE_ALERTS_MODAL]: ServiceAlertsModal,
  [CREATE_RECEIVER_MODAL]: CreateReceiverModal,
  [SEND_MONEY_RECEIVER_MODAL]: SendMoneyReceiverModal,
  [PAYMENT_INSTRUCTION_MODAL]: PaymentInstructionModal,
  [FX_PAYMENT_INSTRUCTION_MODAL]: FxPaymentInstructionModal,
  [CHANGE_PICKUP_LOCATION_TYPE_MODAL]: ChangePickupLocationTypeModal,
  [CANCEL_FX_ADD_TRANSACTION_MODAL]: CancelFxAddTransactionModal,
  [ALERT_MODAL]: AlertModal,
  [REMOVE_PICKUP_LOCATION_BY_PAY_AMOUNT_CHANGE]:
    RemovePickupLocationByPayAmountChangeModal,
  [FX_CALCULATOR_MODAL_TIMEOUT_MODAL]: FxCalculatorModalTimeoutModal,
  [FX_CALCULATOR_MODAL_RATE_TIMEOUT_MODAL]: FxCalculatorModalRateTimeoutModal,
  [PICKUP_LOCATION_PREVIEW_MODAL]: PickupLocationPreviewModal,
  [PICKUP_LOCATION_VIEW_DETAILS_MODAL]: PickupLocationViewDetailsModal,
  [EVENT_IFRAME_MODAL]: EventIframeModal,
  [MAINTENANCE_MODAL]: MaintenanceModal,
  [SYSTEM_ERROR_MODAL]: SystemErrorModal,
  [FX_MAKE_PAYMENT_EXPIRED_MODAL]: FxMakePaymentExpiredModal,
  [FX_DISALLOW_ORDER_MAKE_PAYMENT_MODAL]: FxDisallowOrderMakePaymentModal,
  [REFERRAL_A_FRIEND_CHOOSE_TO_SHARE_MODAL]: ReferralAFiendChooseToShareModal,
  [REGISTER_WELCOME_MODAL]: RegisterWelcomeModal,
  [REFERRAL_LINK_EXPIRED_MODAL]: ReferralLinkExpiredModal,
  [ETA_IFRAME_MODAL]: ETAIframeModal,
  [ADD_PAYTO_ACCOUNT_MODAL]: AddPaytoAccountModal,
  [AUTHORISE_PAYTO_ACCOUNT_MODAL]: AuthorisePaytoAccountModal,
  [AUTHORISE_PAYTO_ACCOUNT_TIMEOUT_MODAL]: AuthorisePaytoAccountTimeoutModal,
  [AUTHORISE_PAYTO_ACCOUNT_SUCCESS_MODAL]: AuthorisePaytoAccountSuccessModal,
  [AUTHORISE_PAYTO_ACCOUNT_REJECT_MODAL]: AuthorisePaytoAccountRejectedModal,
  [EDIT_PAYTO_ACCOUNT_AGREEMENT_MODAL]: EditPaytoAccountAgreementModal,
  [DELETE_PAYTO_ACCOUNT_AGREEMENT_MODAL]: DeletePaytoAccountAgreementModal,
  [UPDATE_PAYTO_ACCOUNT_SUCCESS_MODAL]: UpdatePaytoAccountSuccessModal,
  [PAYTO_NO_CHANGE_MODAL]: PaytoNoChangeModal,
  [PAYTO_OTP_VERIFICATION_MODAL]: PaytoOTPVerificationModal,
  [FX_PICKUP_DATE_NOTICE_POPUP]: FxPickupDateNoticeModal,
  [ACCOUNT_WITH_EMAIL_EXIST_INFORM_MODAL]: AccountWithEmailExistInformModal,
  [PII_VERIFY_NOW_MODAL]: PIIVerifyNowModal,
  [DOCUMENT_UPLOAD_REMINDER_INFORM_MODAL]: DocumentUploadReminderInformModal,
  [FORM_PII_MODAL]: FormPIIModal,
  [FORM_PII_VERIFICATION_SUCCESSFUL_MODAL]: FormPIIVerificationSuccessfulModal,
  [FORM_PII_OTP_VERIFICATION_MODAL]: FormPIIOTPVerificationModal,
  [FORM_PII_PROFILE_DETAILS_EXIST_INFORM_MODAL]:
    FormPIIProfileDetailsExistInformModal,
  [FORM_PII_PROFILE_CONTACT_US_MODAL]: FormPIIProfileContactUsModal,
  [TXN_SUBMIT_ERROR_POPUP]: TxnSubmitErrorModal,
  [CUSTOM_CAMERA_MASK_TO_CAPTURE_PHOTO_MODAL]:
    CustomCameraMaskToCapturePhotoModal,
  [CHECK_CAMERA_TO_TAKE_PHOTO_ENABLE_ALERT_MODAL]:
    CheckCameraToTakePhotoEnableAlertModal,
  [FORM_PROFILE_KYC_MODAL]: FormProfileKYCModal,
  [FORM_PROFILE_KYC_SUCCESSFUL_MODAL]: FormProfileKYCSuccessModal,
  [CANCEL_NAVIGATING_AWAY_FROM_FLOW_MODAL]: CancelNavigatingAwayFromFlowModal,
};
